import { useTranslation } from 'react-i18next';

import type { SourceKind, SourceListItem } from '@/api/generated/schemas.ts';

// What a source is called: its email's subject, else the name of its first file, the one it came as; a document's (a Notion page's),
// a link's, a ticket's, an appointment's, a meeting's and a conversation's without the .md their Markdown is saved as.
const useSourceTitle = () => {
    const { t } = useTranslation();
    return (source: Pick<SourceListItem, 'email' | 'files'> & { kind?: SourceKind }) => {
        const fileName = source.files[0]?.file_name;
        const name = ['document', 'link', 'ticket', 'calendar_event', 'meeting', 'conversation'].includes(
            source.kind ?? ''
        )
            ? fileName?.replace(/\.md$/, '')
            : fileName;
        return source.email?.subject ?? name ?? t('sources.untitled');
    };
};

export default useSourceTitle;
